import { css } from 'linaria';
import { styled } from 'linaria/react';

export const ceilingsPhotoPrintingSection = css`
  display: flex;
  justify-content: space-between;

  @media (--only-mobile) {
    flex-direction: column;
  }
`;

export const ceilingsPhotoPrintingTextWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 372px;

  @media (--only-desktop) {
    width: 292px;
  }

  @media (--only-tablet) {
    width: 314px;
  }

  @media (--only-mobile) {
    width: 100%;
    margin-bottom: 32px;
  }
`;

export const ceilingsPhotoPrintingText = css`
  margin-bottom: 24px;
`;

export const ceilingsPhotoPrintingList = css`
  li {
    column-gap: 16px;
  }
`;

export const ceilingsPhotoPrintingImageWrapper = css`
  display: grid;
  grid-template-columns: 372px 372px;
  grid-template-rows: 206px 206px;
  gap: 32px;

  @media (--only-desktop) {
    grid-template-columns: 292px 292px;
  }

  @media (--only-tablet) {
    grid-template-columns: 314px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
  }
`;

export const CeilingsPhotoPrintingImage = styled.img`
  width: 372px;
  height: 206px;
  cursor: pointer;

  @media (--only-desktop) {
    width: 292px;
  }

  @media (--only-tablet) {
    width: 314px;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const ceilingsPhotoPrintingBigImage = css`
  grid-column-start: 2;
  grid-row: span 2;
  height: 445px;

  @media (--to-desktop) {
    display: none;
  }
`;
